module.exports = __webpack_public_path__ + "static/media/cat walking.5a385107.gif";